import { FieldRenderProps, FieldWrapper } from '@progress/kendo-react-form';

import { Checkbox } from '@progress/kendo-react-inputs';
import { Error, Hint, Label } from '@progress/kendo-react-labels';
import { useMemo } from 'react';
import styles from './CheckBoxFormField.module.scss';

interface IProps extends FieldRenderProps {
  secondLabel?: string;
}

export const CheckBoxFormField = (fieldRenderProps: IProps) => {
  const {
    edit,
    secondLabel,
    value,
    onChange,
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    wrapperStyle,
    optional,
    required,
    ...others
  } = fieldRenderProps;

  const showValidationMessage: string | false | null = touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : '';
  const errorId: string = showValidationMessage ? `${id}_error` : '';

  const elemId = useMemo(() => `checkbox_${new Date().getTime()}`, []);

  const cotent = useMemo(() => {
    return (
      <FieldWrapper>
        <Label
          editorId={id}
          editorValid={valid}
          editorDisabled={disabled}
          optional={optional}
          className={`${edit && required ? 'required' : null}`}
        >
          {label}
        </Label>
        <div className='k-form-field-wrap'>
          <Checkbox
            valid={valid}
            id={id}
            disabled={disabled || !edit}
            className={`k-input k-input-md k-rounded-md ${styles.field}`}
            value={value}
            onChange={onChange}
            {...others}
          >
            <label style={{ paddingLeft: '10px' }} htmlFor={elemId}>
              {secondLabel}
            </label>
          </Checkbox>
          {showHint && <Hint id={hintId}>{hint}</Hint>}
          {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
        </div>
      </FieldWrapper>
    );
  }, [
    disabled,
    edit,
    elemId,
    errorId,
    hint,
    hintId,
    id,
    label,
    onChange,
    optional,
    others,
    secondLabel,
    showHint,
    showValidationMessage,
    valid,
    validationMessage,
    value,
  ]);

  return cotent;
};
